/* eslint-disable sort-keys */
const sharedMessageContainer = {
    '.compact &': {
        justifyContent: 'flex-start',
        marginTop: 0,
    },
    'flexDirection': 'row' as const,
    'justifyContent': 'center' as const,
    'marginTop': 10,
    'variants': {hidden: {true: {opacity: '.25'}}},
}

export const messageContainer = {
    ...sharedMessageContainer,
    display: 'flex',
    flex: 1,
}

export const nativeMessageContainer = {...sharedMessageContainer}

const sharedSpeechBubbleContainer = {flexDirection: 'column' as const}

export const speechBubbleContainer = {
    ...sharedSpeechBubbleContainer,
    display: 'flex',
}

export const nativeSpeechBubbleContainer = {
    ...sharedSpeechBubbleContainer,
    flexShrink: 1,
}

const sharedSpeechBubble = {
    '.compact &': {border: 'none'},
    'alignItems': 'center' as const,
    'backgroundColor': '$messageInfo',
    'borderColor': '$messageInfoBorder',
    'borderWidth': '$messageInfo',
    'borderRadius': '$messageInfo',
    'flexDirection': 'row' as const,
    'flexWrap': 'wrap' as const,
    'marginTop': 4,
    'paddingBottom': '$messageSpeechBubblePaddingVertical',
    'paddingLeft': '$messageSpeechBubblePaddingHorizontal',
    'paddingRight': '$messageSpeechBubblePaddingHorizontal',
    'paddingTop': '$messageSpeechBubblePaddingVertical',
}

export const speechBubble = {
    ...sharedSpeechBubble,
    borderStyle: '$messageInfo',
    display: 'flex',
    lineHeight: 1.4,
}

export const nativeSpeechBubble = {
    ...sharedSpeechBubble,
    alignSelf: 'flex-end' as const,
}

const sharedMessageText = {
    '.compact &': {color: '$messageInfoCompact'},
    'color': '$messageInfoText',
    'fontSize': '$messageInfoText',
}

export const messageText = {
    ...sharedMessageText,
    'fontFamily': '$messageInfoText',
    'fontVariant': '$messageInfoText',
    'fontStyle': '$messageInfoText',
    'lineHeight': '$messageInfoText',
    'display': 'flex',
    '> div': {fontSize: '$messageInfoText'},
    'a': {
        'color': '$messageInfoLink',
        '&:hover': {color: '$messageInfoLinkHover'},
    },
}

export const nativeMessageText = {
    ...sharedMessageText,
    flexShrink: 1,
}

const sharedMessageTime = {
    color: '$messageInfoTimestamp',
    flexGrow: 1,
    fontSize: '$messageTimestamp',
    marginLeft: 10,
    textAlign: 'right' as const,
}

export const messageTime = {
    ...sharedMessageTime,
    whiteSpace: 'nowrap',
}

export const nativeMessageTime = {...sharedMessageTime}

export const messagePrivileged = {
    color: '$messageInfoPrivileged',
    fontSize: '$messageInfoPrivileged',
    paddingLeft: 'calc($sizes$messageInfoIcon + $space$messageInfoIconGap)',
}


const sharedAttributesContainer = {}

export const attributesContainer = {
    ...sharedAttributesContainer,
    display: 'flex',
    flexDirection: 'column',
}

export const nativeAttributesContainer = {
    ...sharedAttributesContainer,
    flexShrink: 1,
}

export const sharedAttributeContainer = {flexDirection: 'row' as const}

export const attributeContainer = {
    ...sharedAttributeContainer,
    display: 'flex',
}

export const nativeAttributeContainer = {...sharedAttributeContainer}

export const sharedIcon = {marginRight: '$messageInfoIconGap'}

export const attributeIcon = {
    ...sharedIcon,
    color: '$messageInfoIcon',
    flex: 'none',
    height: '$messageInfoIcon',
    variants: {
        type: {
            error: {color: '$messageInfoIconError'},
            success: {color: '$messageInfoIconSuccess'},
            warning: {color: '$messageInfoIconWarning'},
        },
    },
    width: '$messageInfoIcon',
}

export const nativeAttributeIcon = {...sharedIcon}

export const ssoWrapper = {
    margin: '10px 0',
    display: 'flex',
    gap: 10,
    justifyContent: 'flex-end',
}
